export default {
    '404': 'Извините, страница не найдена!',
    '500': 'Сервер не отвечает. Попробуйте еще раз позже',
    '503': 'Сервер обновляется. Попробуйте еще раз позже',

    btnHome:'Вернуться на главную'
}
